export const STOCK_STATUS = {
    STOCK: 'stock',
    CLICK_AND_COLLECT: 'click-and-collect',
    OUT_OF_STOCK: 'out-of-stock',
    DESLISTED: 'deslisted',
    NOT_LISTED: 'not-listed',
    NOT_LAUNCHED: 'not-launched'
}

export const VALIDATED = {
    VALIDATED: 1,
    NON_VALIDATED: 0
}

export const STOCK = {
    STOCK: 1,
    OUT_OF_STOCK: 0,
}